module.exports = "/_next/static/images/15c6e54a2b80d694743fdb36ec1cdbf0-payment_delay.png.webp";